import React from "react";

export const Cd = ({ children, style, onClick }) =>
  <div onClick={onClick} className={`bg-s rounded-2xl border border-b0 p-5 shadow-card transition-all duration-150 ${onClick ? "cursor-pointer hover:shadow-card-hover hover:-translate-y-[1px]" : "cursor-default"}`} style={style}>
    {children}
  </div>;
